import Swal from "sweetalert2";

/**
 * Muestra un modal de confirmación que exige escribir una palabra clave exacta,
 * ejecuta la acción (llamada a API / actualización de estado) y maneja
 * automáticamente el feedback de éxito o error.
 *
 * Reemplaza el patrón repetido de:
 *   Swal.fire({... input ...}) -> validar texto -> llamar API -> Swal éxito/error
 *
 * @param {Object}   opciones
 * @param {string}   opciones.titulo          - Título del modal
 * @param {string}   opciones.html            - Contenido HTML del modal (debe incluir el input con id="swal-input-confirm")
 * @param {string}   opciones.palabra         - Palabra que el usuario debe escribir para confirmar
 * @param {Function} opciones.onConfirmar     - Función async que ejecuta la acción real (API, etc.)
 * @param {string}   [opciones.tituloExito]   - Texto del Swal de éxito (default: "Actualizado correctamente")
 * @param {string}   [opciones.tituloError]   - Texto del Swal de error (default: "Ocurrió un error")
 * @param {Object}   [opciones.swalExtra]     - Props adicionales para el Swal.fire de confirmación (ej. confirmButtonColor, didOpen, preConfirm custom)
 * @returns {Promise<boolean>} true si la acción se ejecutó correctamente
 */
export const confirmarConPalabraClave = async ({
    titulo,
    html,
    palabra,
    onConfirmar,
    tituloExito = "Actualizado correctamente",
    tituloError = "Ocurrió un error",
    swalExtra = {},
}) => {
    const { value, isConfirmed } = await Swal.fire({
        title: titulo,
        html,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        focusConfirm: false,
        preConfirm: () => {
            const input = document.getElementById("swal-input-confirm")?.value;
            if (!input || input.toLowerCase() !== palabra.toLowerCase()) {
                Swal.showValidationMessage(`Debes escribir "${palabra}" para continuar.`);
                return false;
            }
            return input;
        },
        ...swalExtra,
    });

    if (!isConfirmed || !value) return false;

    try {
        Swal.fire({
            title: "Procesando...",
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
        });

        await onConfirmar(value);

        await Swal.fire({
            icon: "success",
            title: tituloExito,
            timer: 2000,
            showConfirmButton: false,
        });

        return true;
    } catch (error) {
        console.error(error);
        await Swal.fire({
            icon: "error",
            title: tituloError,
            text: error?.message || "Ocurrió un problema al procesar la solicitud.",
        });
        return false;
    }
};
